import { TerceraChartBaseRenderer } from './TerceraChartBaseRenderer';
export class TerceraChartTimeScaleSeparatorsRenderer extends TerceraChartBaseRenderer {
    constructor(chart, timeScaleRenderer) {
        super(chart);
        this._timeScaleRenderer = timeScaleRenderer;
    }
    Draw(gr, window, windowsContainer, advParams) {
        this._timeScaleRenderer.DrawSeparatorLines(gr);
    }
}
